import {Datagrid, DateField, FunctionField, Link, NumberField, SelectField, TextField} from "react-admin";
import {DatagridPropsWithOptions} from "../../shared/types";
import {initField} from "../../shared/utils";
import {linkToRecord, Record} from "ra-core";
import {Box, Typography} from "@material-ui/core";
import {useOptions} from "../../shared/hooks/useOptions";
import {DownloadInvoicePdfButton} from "../../Invoices/components/DownloadInvoicePdfButton";
import {AddPurchasePaymentStatusButton} from "./AddPurchasePaymentStatusButton";
import {ShowPaymentStatusHistoryButton} from "./ShowPaymentStatusHistoryButton";
import {AddInvoicePaymentStatusButton} from "./AddPaymentStatusButton";
import {LastHistoryField} from "../../components/LastHistoryField";
import {HistoryField} from "../../HistoryField";
import {Tooltip} from "react-leaflet";
import {CiWarning} from "react-icons/ci";
import {getUser} from "../../authProvider";
import {IdentifierField} from "../../components/IdentifierField";


interface PaymentScheduleDatagridProps extends DatagridPropsWithOptions {
    type: any;
}


export const PaymentScheduleDatagrid = ({
                                            options,
                                            type,
                                            ...rest
                                        }: PaymentScheduleDatagridProps) => {

    const {data: optionsStatus} = useOptions("payment_schedule_status", "POST");

    return (
        options &&
        <Datagrid
            {...rest}
            rowStyle={(record: any) => {
                return {
                    backgroundColor:
                        record.invoice.type === "NC" ? "#ffff0050" : "white",
                };
            }}
        >
            {
                getUser().is_admin ?
                    <IdentifierField {...initField("id", options)} /> :
                    <TextField {...initField("id", options)}/>
            }



            <SelectField {...initField("invoice.invoice_type", options, "array")} label={"Tipo"} choices={options.invoice.children.invoice_type.choices} />

            {
                type === "P" ? <FunctionField
                    source="invoice"
                    sortBy="invoice__invoice_number"
                    render={function (record?: Record | undefined, source?: string) {
                        return record && (
                            <Link to={`/invoices/${record.invoice.id}/show`}>
                                {`${record.invoice.type}-${record.invoice.type !== "DC" ? record.invoice.invoice_number : record.invoice.category_document_obj ? record.invoice.category_document_obj.name : ""}`}
                            </Link>
                        )
                    }}
                    label="Fattura"
                /> :
                    <FunctionField
                        source="invoice"
                        sortBy="invoice__sequence_number"
                        render={function (record?: Record | undefined, source?: string) {
                            return record && (
                                <Link to={`/invoices/${record.invoice.id}/show`}>
                                    {`${record.invoice.type}-${record.invoice.type !== "DC" ? record.invoice.invoice_type === "P" ? record.invoice.invoice_number : record.invoice.sequence_number : record.invoice.category_document_obj ? record.invoice.category_document_obj.name : ""}`}
                                </Link>
                            )
                        }}
                        label="Fattura"
                    />
            }

            <FunctionField
                source="invoice__invoice_reference"
                render={function (record?: Record | undefined, source?: string) {
                    return record && record.invoice && record.invoice.invoice_reference && (
                        <Link to={`/invoices/${record.invoice.invoice_reference.id}/show`}>
                            {`${record.invoice.invoice_reference.type}-${ record.invoice.invoice_reference.invoice_type === "P" ? record.invoice.invoice_reference.invoice_number : record.invoice.invoice_reference.sequence_number}`}
                        </Link>
                    )
                }}
                label="Rif."
            />

            <FunctionField
                label="Azienda"
                render={(record: any | undefined) => {
                    if (record && record.invoice.company_object) {
                        return (
                            <Link to={linkToRecord("/subjects", record.invoice.company_object.company.id, "edit")}>
                                <TextField
                                    record={record.invoice.company_object}
                                    source="name"
                                    variant="inherit"

                                />
                            </Link>
                        );
                    }
                    return null;
                }}
                sortBy="invoice__company__company__business_name"
            />
            <DateField
                {...initField("invoice.invoice_date", options)}
                label="Data fattura"
                sortBy="invoice__invoice_date"
            />

            {(type === "T" || type === "P") && <FunctionField
                    label="Fornitore"
                    source="supplier_id"
                    render={(record: any) => {
                        if (record) {
                            return record.invoice.supplier && record.invoice.invoice_type === "P" && (
                                <Link to={linkToRecord("/subjects", record.invoice.supplier.id, "edit")}>
                                    <TextField
                                        record={record.invoice.supplier}
                                        source="business_name"
                                        variant="inherit"
                                    />
                                </Link>
                            );
                        }
                        return null;
                    }}
                    sortBy="invoice__supplier__business_name"
                />
            }
            {
               (type === "T" || type === "S") &&
                    <FunctionField
                        label="Cliente"
                        source="client_id"
                        render={(record: any) => {
                            if (record) {
                                return record.invoice.invoice_type !== "P" && (
                                    <Link to={linkToRecord("/subjects", record.invoice.client.id, "edit")}>
                                        <TextField
                                            record={record.invoice.client}
                                            source="business_name"
                                            variant="inherit"
                                        />
                                    </Link>
                                );
                            }
                            return null;
                        }}
                        sortBy="invoice__client__business_name"
                    />
            }
            <NumberField
                {...initField("invoice.amount", options)}
                label="Imp. fattura"
                sortBy="invoice__amount"
                options={{ style: "currency", currency: "EUR" }}
            />
            <NumberField
                {...initField("amount", options)}
                label="Imp. scadenza"
                sortBy="amount"
                options={{ style: "currency", currency: "EUR" }}
            />
            <NumberField
                {...initField("tot", options)}
                label="Imp. incassato"
                sortBy="tot"
                options={{ style: "currency", currency: "EUR" }}
            />

            <FunctionField
                label="A saldo"
                sortBy="residue"
                render={(record: any) => (
                    <span
                        style={{
                            color: (
                                    (record?.invoice?.invoice_type === "P" &&  record?.invoice?.type !== "NC") ||
                                    (record?.invoice?.invoice_type === "S" &&  record?.invoice?.type === "NC")
                                    ) ? "red" : "green",
                            fontWeight: "bold",
                        }}
                    >
                    <NumberField
                        record={record}
                        source="residue"
                        options={{ style: "currency", currency: "EUR" }}
                    />
                </span>
                )}
            />


            <FunctionField
                {...initField("expiration_date", options)}
                label="Data scadenza"
                render={(record: any) => <DateField {...initField("expiration_date", options)} />
                }
            />
            <FunctionField
                {...initField("expiration_date", options)}
                label=" "
                render={(record: any) => {
                    const color =
                        new Date(record.expiration_date) > new Date() ? "green" : "red";
                    return (
                        <Box display={"flex"} alignItems={"center"}>
                            {((record.last_payment_status && record.last_payment_status.status !== "I") ||
                                !record.last_payment_status) && (
                                <div
                                    style={{
                                        backgroundColor: color,
                                        width: "30px",
                                        height: "30px",
                                        borderRadius: "100%",
                                        marginRight: "10px",
                                    }}
                                />
                            )}
                        </Box>
                    );
                }}
                sortable={false}
            />

            <TextField {...initField("terms_payment.method", options)} sortBy={"payment_method_label"} label="Con pag"/>

            <DownloadInvoicePdfButton label="PDF fattura" paymentSchedule/>

            <FunctionField
                {...initField("last_payment_status", options)}
                label={"Stato pagamento"}
                render={(record: any) => {
                    return (record.last_payment_status && optionsStatus) && (
                        <SelectField
                            record={record.last_payment_status}
                            {...initField("status", optionsStatus, "array")}
                            choices={optionsStatus.status.choices}
                        />
                    )
                }
                }
                sortBy={"last_payment_status__status"}
            />

            <DateField
                {...initField("last_payment_status.date", options,)}
                label={"Data ultimo stato"}
                sortBy={"last_payment_status__date"}
            />

            <TextField
                {...initField("last_payment_status.notes", options)}
                label="Note utimo stato"
                sortBy={"last_payment_status__notes"}
            />
            <FunctionField
                {...initField("last_payment_status.bank", options)}
                label={"Banca"}
                render={(record: any) => {
                    return (record.last_payment_status && record.last_payment_status.bank ) && (
                        record.last_payment_status.bank.name
                    )
                }
                }
                sortBy={"last_payment_status__bank__name"}
            />

            <FunctionField
                render={(record: any) => (
                    <>
                        <ShowPaymentStatusHistoryButton/>
                        {record?.last_payment_status?.status !== "I" &&
                            (record.invoice.invoice_type === "P" ? (
                                <AddPurchasePaymentStatusButton/>
                            ) : (
                                <AddInvoicePaymentStatusButton/>
                            ))}
                    </>
                )}
            />
            {
                getUser()?.is_admin && <HistoryField label="Logs" />
            }
        </Datagrid>
    )
};
